export default "__VITE_ASSET__D0YrwSbI__"